<template>
    <b-modal ref="mdlPazienteRefertoModalComponent" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl">
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Data Refertazione</label>
                    <date-picker v-model="jsonData.dataRefertazione" format="DD-MM-YYYY HH:mm " value-type="timestamp" type="datetime"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <div style="flex: 1; height: 100%; background-color: transparent; overflow: hidden; flex-direction: column">
                        <label class="sa-label-data">Descrizione:</label>
                        <vue-editor class="sa-qeditor" style="min-height: 180px" :editor-toolbar="customToolbar" v-model="jsonData.descrizione" />
                    </div>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onClickSaveReferto()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError, DatePicker },
    data() {
        return {
            pathResource: "/rsapazientereferti",
            jsonData: {
                descrizione: null,
                idAccettazione: null,
                dataRefertazione: new Date().getTime(),
            },
            title: "Nuovo Referto",

            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
        };
    },
    methods: {
        show(id) {
            let me = this;
            me.title = "Nuovo Referto";
            me.jsonData.idAccettazione = id;
            // console.log("show", me.jsonData.idAccettazione);
            me.$refs.mdlPazienteRefertoModalComponent.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonData = { descrizione: null };
            me.$refs.mdlPazienteRefertoModalComponent.hide();
        },
        onClickSaveReferto() {
            let me = this;
            // console.log("onClickSaveReferto", me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveRefertoSuccess, me.saveRefertoError);
        },
        openModal(id, idAccettazione) {
            let me = this;
            me.jsonData.id = id;
            me.jsonData.idAccettazione = idAccettazione;
            me.$refs.mdlPazienteRefertoModalComponent.show();
        },

        saveRefertoSuccess(response) {
            let me = this;
            me.$refs.mdlPazienteRefertoModalComponent.hide();
            me.$bvToast.toast("Salvataggio avvvenuto con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });

            me.$emit("saveSuccess", response.data.data);
        },
        saveRefertoError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error);
        },
        showModifica(id) {
            let me = this;
            me.title = "Modifica Referto";

            me.loadDataResources(me.pathResource + "/" + id, null, me.loadRefertoSuccess, me.loadRefertoError);
        },
        loadRefertoSuccess(response) {
            let me = this;
            me.$emit("saveSuccess");
            me.jsonData = response.data.data;
            me.$refs.mdlPazienteRefertoModalComponent.show();
        },
        loadRefertoError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error);
        },
    },
};
</script>
<style></style>
